<template>
  <div
    class="doc-card"
    :class="{ 'is-selected': isSelected, 'is-context': contextMenu.visible }"
    @click="(e) => selectFile(e)"
    @dblclick="$emit('contextAction', { action: 'edit', document: doc })"
    @contextmenu.prevent="showContextMenu"
  >
    <div class="doc-card__preview">
      <div class="doc-card__icon">
        <svg viewBox="0 0 40 52" fill="none" xmlns="http://www.w3.org/2000/svg" class="doc-card__file-svg">
          <path d="M0 4C0 1.79 1.79 0 4 0H24L40 16V48C40 50.21 38.21 52 36 52H4C1.79 52 0 50.21 0 48V4Z" fill="#2a2d3a"/>
          <path d="M24 0L40 16H28C25.79 16 24 14.21 24 12V0Z" fill="#3d415a"/>
          <rect x="8" y="24" width="20" height="2" rx="1" fill="#4a4f6a"/>
          <rect x="8" y="30" width="24" height="2" rx="1" fill="#4a4f6a"/>
          <rect x="8" y="36" width="16" height="2" rx="1" fill="#4a4f6a"/>
          <rect x="8" y="42" width="22" height="2" rx="1" fill="#4a4f6a"/>
        </svg>
      </div>
      <div class="doc-card__check" v-if="isSelected">
        <i class="fa fa-check"></i>
      </div>
    </div>

    <div class="doc-card__info">
      <span class="doc-card__name" :title="displayName">{{ displayName }}</span>
      <span class="doc-card__meta" v-if="doc.updated_at">{{ formatDate(doc.updated_at) }}</span>
    </div>

    <DocumentContextMenu
      :visible="contextMenu.visible"
      :position="contextMenu.position"
      :document="doc"
      @action="handleContextAction"
    />
  </div>
</template>

<script>
import DocumentContextMenu from "./DocumentContextMenu.vue";

export default {
  name: "DocumentIcon",
  components: { DocumentContextMenu },
  props: {
    doc: { type: Object },
    library: { type: Object },
    dir: { type: String },
    itemsSelected: { type: Array },
    viewMode: { type: String, default: "grid" },
  },
  data() {
    return {
      contextMenu: {
        visible: false,
        position: { x: 0, y: 0 },
      },
    };
  },
  computed: {
    isSelected() {
      return !!this.itemsSelected.find((i) => i.name === this.doc.name);
    },
    displayName() {
      return this.doc.name.replace(this.dir, "").replace("/", "");
    },
  },
  methods: {
    selectFile(event) {
      this.$emit("selectFile", event);
    },
    formatDate(d) {
      if (!d) return "";
      const date = new Date(d);
      return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    },
    showContextMenu(event) {
      this.$emit("showContextMenu", this.doc.name);
      this.contextMenu.position = { x: event.clientX, y: event.clientY };
      this.contextMenu.visible = true;
      const closeMenu = () => {
        this.contextMenu.visible = false;
        document.removeEventListener("click", closeMenu);
      };
      setTimeout(() => document.addEventListener("click", closeMenu), 0);
    },
    closeContextMenu() {
      this.contextMenu.visible = false;
    },
    handleContextAction(action) {
      this.contextMenu.visible = false;
      this.$emit("contextAction", { action, document: this.doc });
    },
  },
};
</script>

<style scoped lang="scss">
.doc-card {
  display: flex;
  flex-direction: column;
  background: var(--bg-card);
  border: 1px solid var(--border-default);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.18s ease;
  overflow: hidden;

  &:hover {
    border-color: var(--border-hover, #4e5058);
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);

    .doc-card__preview { background: rgba(0, 0, 0, 0.2); }
  }

  &.is-selected {
    border-color: var(--primary-start);
    box-shadow: 0 0 0 2px rgba(91, 124, 246, 0.2);

    .doc-card__preview { background: rgba(91, 124, 246, 0.06); }
  }

  &.is-context {
    border-color: var(--primary-start);
    box-shadow: 0 0 0 2px rgba(91, 124, 246, 0.15);
  }
}

.doc-card__preview {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 20px 24px;
  background: rgba(0, 0, 0, 0.15);
  transition: background 0.18s ease;
}

.doc-card__icon {
  width: 56px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2));
}

.doc-card__file-svg {
  width: 100%;
  height: 100%;
}

.doc-card__check {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--primary-start);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  box-shadow: 0 2px 6px rgba(91, 124, 246, 0.35);
}

.doc-card__info {
  padding: 12px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-top: 1px solid var(--border-default);
}

.doc-card__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.doc-card__meta {
  font-size: 11px;
  color: var(--text-secondary, #8b8d94);
  line-height: 1.3;
}
</style>
